import React from 'react'

const Footer = () => {
  return (
    <div className='bg-gray-800  py-3  mt-2 gap-5  grid grid-cols-1 md:grid-cols-4 px-2'>
      <div className='cols-span-1 ml-5 md:pl-20'>
        <h1 className='text-2xl capitalize text-white '>Contact info</h1>
        <ul>
          <li className='text-green-400 py-2'>03410704891</li>
          <li className='text-green-400 py-2'>whatsapp </li>
          <li className='text-green-400 py-2'>facebook</li>
        </ul>
      </div>
      <div className='cols-span-1 ml-5 md:pl-20'>
        <h1 className='text-2xl capitalize text-indigo-600'>follow us </h1>
        <ul>
          <li className='text-green-400 py-2'>twitter</li>
          <li className='text-green-400 py-2'>whatsapp </li>
          <li className='text-green-400 py-2'>facebook</li>
        </ul>
      </div>
      <div className='cols-span-1 ml-5 md:pl-20'>
        <h1 className='text-2xl capitalize text-blue-400'>Project Details</h1>
        <ul>
          <li className='text-green-400 py-2'>tailwind for UI</li>
          <li className='text-green-400 py-2'>Reactjs </li>
          <li className='text-green-400 py-2'>Jsx And react router</li>
        </ul>
      </div>
    </div>
  )
}

export default Footer